import React, {Component} from 'react';
import { map } from "lodash";
import { message } from 'antd';
import moment from "moment-timezone";
import Loader from "../../../Common/Component/Loader";
import Sidebar from '../../../Common/Component/Sidebar';
import ServiceInfo from "./ServiceInfo";
import BillingInfo from "./BillingInfo";

class AddCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      loader: false,
      currentTab: 0,
      basicDetails:{},
      serviceInfo: {},
      billingInfo:{}
    }
  }

  componentDidMount = () => {
    this.props.resetPricingCalculator();
    this.props.resetCheckZipcode();
    this.onClearStorage();
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy();
    if (nextProps?.ServiceOrder && nextProps?.ServiceOrder?.addOrder && Object.keys(nextProps?.ServiceOrder?.addOrder).length > 0
        && JSON.stringify(nextProps?.ServiceOrder?.addOrder) !== JSON.stringify(this.props?.ServiceOrder?.addOrder)) {
      message.success("Customer created successfully.", 10);
      this.setState({ loader: false, addOrder: nextProps?.ServiceOrder?.addOrder }, () =>
        // this.addCustomerCards(nextProps?.ServiceOrder?.addOrder.user_uuid), 
        this.updateCustomer(nextProps?.ServiceOrder?.addOrder.user_uuid)
      );
    }
    if (Object.keys(nextProps?.CustomerList?.customer).length > 0) {
      setTimeout(() => {
        this.afterAddCustomer();
      }, 1000);
      this.onClearStorage();
    }

    if (Object.keys(nextProps?.PricingCalc?.data).length > 0 && nextProps?.PricingCalc?.data !== this.props?.PricingCalc.data) {
      this.setState({ loader: false });
    }
  }

  // addCustomerCards = (user_uuid) => {
  //   const {cardList} = this.state.billingInfo;
  //   if(cardList.length > 1 ){
  //     for (let index = 0; index < cardList.length; index++) {
  //       if(cardList[index].id !== this.state.billingInfo.user_billing_info_uuid){
  //         this.props.addNewCard({
  //           'user_uuid': user_uuid,
  //           'stax_card_token' : cardList[index].id,
  //           'firstname':cardList[index].customer.firstname,
  //           'lastname':cardList[index].customer.lastname,
  //           charge_invoice_card: true,
  //         })
  //       }
  //     }
  //   } 
  // }

  updateCustomer = (user_uuid) => {
    const { emails, is_dummy_email } = this.state.basicDetails;
    if (user_uuid) {
      this.props.updateCustomer(user_uuid, { emailaddress_set: emails, is_dummy_email: is_dummy_email });
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  afterAddCustomer = () => {
    const { addOrder } = this.state;
    this.props.history.push(`/residential/detail`, { query: { 'id': addOrder?.user_uuid, hear_about_us: addOrder?.hear_about_us, customer_satisfaction_score: addOrder?.customer_satisfaction_score } })
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  onClearStorage = () => {
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
    sessionStorage.removeItem('basicDetail');
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  onTabChange = (value) => {
    this.setState({currentTab: value})
  };

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  setBasicData = (data) => {
    this.setState({ basicDetails: data }, () => {
    });   
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  setServiceInfoData = (data) => {
    this.setState({ serviceInfo: data }, () => {
    });    
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  setBillingInfoData = (data) => {
    this.setState({ billingInfo: data }, () => {
    });    
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  createServiceOrder = () => {
    const { basicDetails, serviceInfo, billingInfo} = this.state;
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));
    let pets = [];
    const { extra_pet, dogCount } = serviceInfo;
    const numberOfDogs = extra_pet === "" ? dogCount : extra_pet;

    for (let i = 0; i < numberOfDogs; i++) {
      pets.push({
        name: '',
        breed: '',
        birthday: null,
        is_friendly: false,
        can_treat: false,
        additional_info: '',
        photo: ''
      });
    }

    let area_to_clean = [];

    if (serviceInfo?.areaClean && serviceInfo?.areaClean.length > 0) {
      area_to_clean = serviceInfo?.areaClean;
      const idx = area_to_clean.indexOf("");
      
      if (idx > -1) {
        area_to_clean[idx] = serviceInfo?.otherCleaning;
      }
    }

    const primaryEmail =  basicDetails?.emails.filter(email => {
      return email.primary
    });

    this.props.addServiceOrder({
      field_office_uuid: serviceInfo?.franchises?.[0]?.uuid,
      service_type: "residential",
      property_type: serviceInfo?.propertyType || null,
      frequency: serviceInfo?.frequency || null,
      service_add_ons: serviceInfo?.add_ons || [],
      pet_count: numberOfDogs || null,
      pets: pets,
      area_to_clean: area_to_clean,
      last_cleaned: serviceInfo?.lastCleaned || null,
      service_address: {
        city: billingInfo?.service_address?.city,
        state: billingInfo?.service_address?.state,
        address: billingInfo?.service_address?.address,
        zip_code: billingInfo?.service_address?.zip_code       
      },
      billing_address: {
        city: billingInfo?.billing_address?.city,
        state: billingInfo?.billing_address?.state,
        address: billingInfo?.billing_address?.address,
        zip_code: billingInfo?.billing_address?.zip_code,
        address2:billingInfo?.billing_address?.address2       
      },
      preferred_start_date: billingInfo?.preferred_start_date ? moment(billingInfo?.preferred_start_date).format("YYYY-MM-DD")  : null,
      is_billing_address_same: billingInfo?.isBillingAddress,
      first_name: basicDetails?.firstName || null,
      last_name: basicDetails?.lastName || null,
      email: (primaryEmail && primaryEmail[0] && primaryEmail[0].email) || null,
      is_dummy_email:basicDetails?.is_dummy_email ? true : false, 
      phone_numbers: basicDetails?.phone_numbers || null,
      preferred_contact_methods: billingInfo?.contactMethods || null,
      cleaning_notes: serviceInfo?.cleaningNotes || '',
      disposal_location: serviceInfo?.disposalLocation || '',
      prepay_months: calcData ? calcData?.prepay_months : null,
      is_prepaid: calcData ? calcData?.isPrePay : false,
      coupon_code: calcData ? calcData?.coupon_code : '',
      is_authorize_charge_each_month: true,
      stax_card_token: billingInfo?.user_billing_info_uuid ?  billingInfo?.user_billing_info_uuid : billingInfo?.stax_public_apikey ? billingInfo?.stax_public_apikey : null,
      is_print_and_mail_invoices: billingInfo?.is_print_and_mail_invoices || false,
      is_email_invoice: billingInfo?.is_email_invoice || false,
      // preferred_technician_uuid: billingInfo?.preferred_technician_uuid || null,
      is_terms_accepted: billingInfo?.isAgreed || false,
      payment_method_type:billingInfo?.payment_method,
      authorized_user: basicDetails.authorizedUser,
      hear_about_us: basicDetails?.hear_about_us || [],
      outreach: 'franchisee',
      //should add here the outreach
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3294></DP-3294>
   */
  priceCalc = () => {
    // const {  serviceInfo } = this.state;
    const serviceInfo = JSON.parse(sessionStorage.getItem("step1"));
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));
    const {dogCount, frequency, areaClean, propertyType, lastCleaned, add_ons, extra_pet, is_extra_pet} = serviceInfo || {};
    const service_add_ons = []
    map(add_ons, obj => {
      if (obj?.add_on_uuid) service_add_ons.push({uuid: obj?.add_on_uuid, add_on_name: obj?.name, is_recurring: obj?.is_recurring || false})
    });
    const is_dog_count = is_extra_pet && parseInt(extra_pet) > 0 ? extra_pet : dogCount;
    if (serviceInfo?.franchises?.[0]?.uuid && frequency && is_dog_count && propertyType && lastCleaned) {
      this.setState({loader: true})
      const data = {
        'field_office_uuid': serviceInfo?.franchises?.[0]?.uuid,
        'frequency': frequency,
        'pet_count': is_dog_count,
        'last_cleaned': lastCleaned,
        'property_type': propertyType,
        'areas_to_clean': areaClean,
        'add_ons': service_add_ons,
        'is_prepaid': calcData && calcData.isPrePay ? calcData.isPrePay : false,
        'prepay_months': calcData && calcData.isPrePay ? calcData.prepay_months : null
      }
      if (calcData && calcData.coupon_code) Object.assign(data, {'coupon_code': calcData?.coupon_code});
      this.props.pricingCalculator(data);
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  renderTabs = () => {
    const { currentTab, basicDetails, serviceInfo, billingInfo } = this.state;
    switch (currentTab) {
    case 0:
      return(
        <ServiceInfo
          //reducer
          zipcodeCheck={this.props.ZipcodeCheck}
          PricingCalc={this.props.PricingCalc}
          GoogleApi={this.props.GoogleApi}
          
          //api
          checkEmail={this.props.checkEmail}
          pricingCalculator={this.props.pricingCalculator}
          checkZipCode={this.props.checkZipCode}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetCheckZipcode={this.props.resetCheckZipcode}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          priceCalc={this.priceCalc}

          EmailVerifycation={this.props.EmailVerifycation}
          onTabChange={this.onTabChange}
          setServiceInfoData={this.setServiceInfoData}
          setBasicData={this.setBasicData}
          serviceInfo={this.serviceInfo}
          history={this.props.history}
        />
      )
    case 1:
      return(
        <BillingInfo
          onTabChange={this.onTabChange}
          basicDetails={basicDetails}
          serviceInfo={serviceInfo}
          billingInfo={billingInfo}

          //Reducer
          zipcodeCheck={this.props.ZipcodeCheck}
          PricingCalc={this.props.PricingCalc}
          GooleApi={this.props.GoogleApi}
          EmailVerifycation={this.props.EmailVerifycation}
          
          //Api
          pricingCalculator={this.props.pricingCalculator}
          checkZipCode={this.props.checkZipCode}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetCheckZipcode={this.props.resetCheckZipcode}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          priceCalc={this.priceCalc}
          // addNewCard={this.props.addNewCard}
          getFieldOfficeById={this.props.getFieldOfficeById}
          getFieldTechnicianFilter={this.props.getFieldTechnicianFilter}
          FieldTechnicianFilter={this.props.FieldTechnicianFilter}
          setServiceInfoData={this.setServiceInfoData}
          setBasicData={this.setBasicData}
          setBillingInfoData={this.setBillingInfoData}
          createServiceOrder={this.createServiceOrder}
          ValidateCouponCode={this.props.ValidateCouponCode}
          validateCoupon={this.props.validateCoupon}
          checkEmail={this.props.checkEmail}
          history={this.props.history}
        />
      )
    default:
      return(
        <ServiceInfo
          //reducer
          zipcodeCheck={this.props.ZipcodeCheck}
          PricingCalc={this.props.PricingCalc}
          GoogleApi={this.props.GoogleApi}
          //api
          checkEmail={this.props.checkEmail}
          pricingCalculator={this.props.pricingCalculator}
          checkZipCode={this.props.checkZipCode}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetCheckZipcode={this.props.resetCheckZipcode}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          priceCalc={this.priceCalc}

          onTabChange={this.onTabChange}
          setServiceInfoData={this.setServiceInfoData}
          setBasicData={this.setBasicData}
          serviceInfo={this.serviceInfo}
          getServiceInfoData={this.getServiceInfoData}
          history={this.props.history}
          EmailVerifycation={this.props.EmailVerifycation}
        />
      )
    }
  }

  backToResidentialList = () =>{
    this.onClearStorage();
    this.props.history.push('/residential');
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  render() {
    const {loader} = this.state;
    return (
      <div id="wrapper">
        <div className="content-area">
          <div className="mt-10 mb-10 ml-30">
            <ul className="breadcrumb">
              <li
                onClick={() => this.backToResidentialList()}
                className="fs-14"
              >
                <span className="pointer">
                  <i className="las la-angle-left"></i> 
                  Back to All Residential Customers
                </span>
              </li>
            </ul>
          </div>
          <Sidebar />
          <div className="fluid">
            {loader && <Loader />}
            {this.renderTabs()}
          </div>
        </div>
        
      </div>
    )
  }
}

export default AddCustomer;